<template>
  <div class="section-tracking">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $t('globalLocator.sections.tracking') }}</span>
      </b-col>
    </b-row>
    <b-row class="px-3 pt-2">
      <b-col>
        <b-row
          v-for="(item, index) in trackingElements.slice().reverse()"
          :key="index"
          class="tl-row"
        >
          <b-col
            cols="auto"
            class="d-flex align-items-center mb-4"
          >
            {{ item.changeDate | datetime }}
          </b-col>
          <b-col
            cols="auto"
            class="p-0"
          >
            <div class="tr-circle d-flex align-items-center justify-content-center" />
            <div
              v-if="trackingElements.length > 1"
              class="time-line"
            />
          </b-col>
          <b-col class="d-flex align-items-center">
            <div class="arrow-bubble" />
            <div class="speech-bubble mb-4">
              <div class="arrow left" />
              <b-row class="px-3">
                <b-col cols="auto">
                  <div class="d-flex flex-column align-items-start justify-content-start">
                    <small>{{ $t('globalLocator.labels.status') }}</small>
                    <translated-entity-badge
                      class="status-badge mr-2"
                      :value="item.status"
                      :values="states"
                    />
                  </div>
                </b-col>
                <b-col>
                  <div class="d-flex flex-column align-items-start justify-content-start">
                    <small>{{ $t('globalLocator.labels.user') }}</small>
                    <span class="tracking-text">{{ item.userapp.fullName }}</span>
                  </div>
                </b-col>
                <b-col v-if="item.laboratory">
                  <div class="d-flex flex-column align-items-start justify-content-start">
                    <small>{{ $t('globalLocator.labels.laboratory') }}</small>
                    <span class="tracking-text">{{ item.laboratory.labName }}</span>
                  </div>
                </b-col>
              </b-row>
              <span v-if="statusWithAdditionalInfo(item)">
                <b-row>
                  <b-col>
                    <hr class="my-2">
                  </b-col>
                </b-row>
                <b-row v-if="item.locationLabel">
                  <b-col class="text-left additional-information">
                    <i
                      class="fas fa-map-marker main mr-2"
                      aria-hidden="true"
                    />
                    <span class="is-italic">{{ item.locationLabel }}</span>
                  </b-col>
                </b-row>
                <b-row v-if="item.unarchivingReason">
                  <b-col class="text-left additional-information">
                    <div>
                      <i
                        class="fas fa-info main mr-2"
                        aria-hidden="true"
                      />
                      <span class="is-italic">{{ `${$t('globalLocator.labels.reason')} : ${item.unarchivingReason.name}` }}</span>
                    </div>
                    <div>
                      <small>{{ item.unarchivedWithReturnOption ? $t('archive.modal.shouldBeReturned') : $t('archive.modal.shouldNotBeReturned') }}</small>
                    </div>
                  </b-col>
                </b-row>
              </span>
            </div>
          </b-col>
        </b-row>
        <!-- TODO: Elemento mockeado y oculto de cómo debería representarse el salto de un laboratorio a otro -->
        <!-- TODO: Hablar con Fernando UX para los diferentes iconos a mostrar y textos -->
        <!--<b-row>
                    <b-col>
                        <hr>
                    </b-col>
                </b-row>
                <b-row class="tl-row">
                    <b-col cols="auto" class="d-flex align-items-center mb-4">
                        06/03/2020 08:14
                    </b-col>
                    <b-col cols="auto" class="p-0">
                        <div class="tr-circle d-flex align-items-center justify-content-center">
                        </div>
                    </b-col>
                    <b-col class="d-flex align-items-center">
                        <div class="arrow-bubble"></div>
                        <div class="speech-bubble mb-4">
                            <div class="arrow left"></div>
                            <b-row class="px-3 mt-1">
                                <b-col>
                                    <i class="main icon-box-send" aria-hidden="true"></i>
                                    <span class="main mx-2">{{ $t('exchanges.tracking.sent') }}: </span>
                                    <span><b>anatomical pathology3</b></span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>-->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TranslatedEntityBadge from '@/components/common/TranslatedEntityBadge'
import requestService from '@/api/resources/common/commonRequestService'
import caseService from '@/api/resources/common/commonCaseServices'
import sampleService from '@/api/resources/common/commonSampleService'
import portionService from '@/api/resources/common/commonPortionServices'
import subportionService from '@/api/resources/common/commonSubportionServices'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'

export default {
    name: 'TrackingSection',
    components: {
        TranslatedEntityBadge
    },
    props: {
        entityType: { type: String, required: true },
        entityValue: { type: Object, required: true },
        laboratoryId: { type: Number, required: true },
        states: { type: Array, required: true }
    },
    data() {
        return {
            trackingElements: []
        }
    },
    methods: {
        statusWithAdditionalInfo(status) {
            return status.locationLabel || status.unarchivingReason
        },
        async loadTrackingElements() {
            try {
                switch (this.entityType) {
                case IDENTIFIER_SCOPES.REQUEST:
                    this.trackingElements = await requestService.getTracking(this.laboratoryId, this.entityValue.id)
                    break
                case IDENTIFIER_SCOPES.CASE:
                    this.trackingElements = await caseService.getTracking(this.laboratoryId, this.entityValue.id)
                    break
                case IDENTIFIER_SCOPES.SAMPLE:
                    this.trackingElements = await sampleService.getTracking(
                        this.laboratoryId,
                        this.entityValue.caseStudy.id,
                        this.entityValue.id)
                    break
                case IDENTIFIER_SCOPES.PORTION:
                    this.trackingElements = await portionService.getTracking(
                        this.laboratoryId,
                        this.entityValue.sample.caseStudy.id,
                        this.entityValue.sample.id,
                        this.entityValue.id)
                    break
                case IDENTIFIER_SCOPES.SUBPORTION:
                    this.trackingElements = await subportionService.getTracking(
                        this.laboratoryId,
                        this.entityValue.portion.sample.caseStudy.id,
                        this.entityValue.portion.sample.id,
                        this.entityValue.portion.id,
                        this.entityValue.id)
                    break
                }
            } catch (e) {
                this.showErrorModalGlobal()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  .tr-circle{
    width: 25px;
    height: 25px;
    border: 2px solid vt-color(primary);
    border-radius: 50%;
    background: vt-color(white-light);
    position: relative;
    z-index: 5;
    margin: 15px 10px 10px 10px;
  }

  .time-line{
    width: 3px;
    height: 100%;
    background: vt-color(primary);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top:0;
    position: absolute;
  }

  .tl-row:first-child .time-line{
    top: 30%;
  }

  .tl-row:last-child .time-line{
    height: 30%;
  }

  .speech-bubble .description{
    line-height: 20px;
  }

  .speech-bubble .title,
  .speech-bubble .tracking-text {
    font-size: font-size(very-small) !important;
    color: vt-color(dark-text);
    text-align: left;
    white-space: nowrap;
  }

.speech-bubble {
    background-color: vt-color(white-light);
    border: 1px solid #c8c8c8;
    border-radius: 5px;
    text-align: center;
    padding: 10px;
    position: relative;
    box-shadow: 1px 1px 5px 0 hsla(0, 0%, 49%, 0.64);
}

.speech-bubble .arrow {
    border-style: solid;
    position: absolute;
}

.left {
    border-color: #c8c8c8 transparent transparent transparent;
    border-width: 8px 8px 0px 8px;
    left: -12px;
    top: calc(50% - 5px);
    transform: rotate(90deg);
}

.left:after {
    border-color: vt-color(white-light) transparent transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0px 7px;
    bottom: 1px;
    content: "";
    position: absolute;
    left: -7px;
}

.additional-information {
    font-size: font-size(small);
}

.additional-information small {
    text-transform: uppercase;
}

</style>
